import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { TouchableWithoutFeedback, View } from 'react-native';
import classNames from 'classnames';

import GlowPoint from '../glow-point';

import styles from './calendar.styles';

export default class CalendarDay extends PureComponent {
  selectDate = () => {
    const { disabled, inCurrentMonth, onSelectDate, day } = this.props;

    if (!disabled && inCurrentMonth && typeof onSelectDate === 'function') {
      onSelectDate(new Date(Date.UTC(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate())));
    }
  };

  render() {
    const { disabled, highlighted, day, inCurrentMonth } = this.props;
    const dayCssClass = classNames('day-text', { 'disable-day': disabled});

    return (<TouchableWithoutFeedback
      onPress={this.selectDate}>
        <div className="calendar-day">
          {inCurrentMonth && [
            <span className={dayCssClass} key="dayText">
              {day.getDate()}
            </span>,
             highlighted && <span key="glow-point" className="glow-point-wrapper"><GlowPoint key="point" radius={4} /></span>,

          ]}
        </div>
    </TouchableWithoutFeedback>);
  }
}

CalendarDay.propTypes = {
  day: PropTypes.instanceOf(Date),
  inCurrentMonth: PropTypes.bool,
  highlighted: PropTypes.bool,
  disabled: PropTypes.bool,
  onSelectDate: PropTypes.func,
};
